import { useCurrentSpaceStore as e } from "../stores/current-space-store/useCurrentSpaceStore.js";
//#region src/lib/hooks/useIsECommerceEnabled.ts
var t = () => {
	let t = e((e) => e.space);
	return t ? t.shopifyInfo?.isEcommerceActive === !0 : !1;
};
//#endregion
export { t as useIsECommerceEnabled };
